/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { createSlice } from '@reduxjs/toolkit';
import { type SalePayment } from '../../Customer/store/customerTypes';
import { getSaleTypes, getUnpledgedSales, getUndisbursedSales, getUnapprovedSales, getUnsettledSalePayments, getUnapprovedSalePayments } from './salesMiddleware';
import { type Metal } from './salesTypes';

interface InitialState {
  metal: Metal[];
  unpledgedSales: string[];
  undisbursedSales: string[];
  unapprovedSales: string[];
  unsettledPayments: SalePayment[];
  unapprovedPayments: SalePayment[];
}

const initialState: InitialState = {
  metal: [],
  unpledgedSales: [],
  undisbursedSales: [],
  unapprovedSales: [],
  unsettledPayments: [],
  unapprovedPayments: [],
};

const salesReducer = createSlice({
  name: 'salesReducer',
  reducers: {
    resetUnpledgedSales(state) {
      state.unpledgedSales = initialState.unpledgedSales;
    },
  },
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getSaleTypes.fulfilled, (state, action) => {
      state.metal = action.payload.metals;
    });
    builder.addCase(getUnpledgedSales.fulfilled, (state, action) => {
      state.unpledgedSales = action.payload;
    });
    builder.addCase(getUndisbursedSales.fulfilled, (state, action) => {
      state.undisbursedSales = action.payload;
    });
    builder.addCase(getUnapprovedSales.fulfilled, (state, action) => {
      state.unapprovedSales = action.payload;
    });
    builder.addCase(getUnapprovedSalePayments.fulfilled, (state, action) => {
      state.unapprovedPayments = action.payload;
    });
    builder.addCase(getUnsettledSalePayments.fulfilled, (state, action) => {
      state.unsettledPayments = action.payload;
    });
  },
});

export const { resetUnpledgedSales } = salesReducer.actions;
export default salesReducer.reducer;
